import React from 'react'
import { withRouter } from 'next/router'
import Link from 'next/link'
import { useSelector, useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { isAppRoute } from 'paths'
import { actionCreators as authActionCreators } from '@blocket/authentication-fe'
import getCurrentUrl, { buildListUrl } from 'utils/url'
import Cookies from 'universal-cookie'
import domainName from 'utils/domainName'
import { withDevice } from 'plugins/device'
import { TabBar as BuiTabBar } from '@blocket/blocket-ui'

export const onAdInsertClick = () => {
  const cookies = new Cookies()
  cookies.set('AdInsertCancelUrl', getCurrentUrl(), {
    path: '/',
    secure: false,
    httpOnly: false,
    maxAge: 60 * 60 * 24, // 24 hours
    domain: `.${domainName.getBaseDomain(getCurrentUrl())}`,
  })
}

const TabBar = ({ router }) => {
  const userInfo = useSelector((state) => state.account.user)
  const unreadMessagesCount = useSelector((state) => state.chat.unreadMessagesCount)
  const searchParams = useSelector((state) => state.searchParams)
  const adWatchesNewCount = useSelector((state) => state.adWatchesCount.adWatchesNewCount)

  const dispatch = useDispatch()
  const adsUrl = buildListUrl({ r: searchParams.defaultRegion }, searchParams.byQueryKey)
  const redirectUrl = router.pathname
  const cancelUrl = router.pathname

  const onLoginClick = (e) => {
    e.preventDefault()
    dispatch(authActionCreators.blocketLoginHelper.goToLogin(redirectUrl, cancelUrl, 'menu'))
  }

  return (
    <BuiTabBar
      userInfo={userInfo}
      unreadMessagesCount={unreadMessagesCount}
      adWatchesNewCount={adWatchesNewCount}
      adsUrl={adsUrl}
      adInsertUrl="/mina-annonser/lagg-in-annons"
      isAppRoute={isAppRoute}
      linkComponent={({ href, children, ...props }) => (
        <Link href={href}>
          <a {...props}>{children}</a>
        </Link>
      )}
      onLoginClick={onLoginClick}
      onAdInsertClick={onAdInsertClick}
      pathname={router.pathname}
    />
  )
}

TabBar.propTypes = {
  router: PropTypes.object.isRequired,
}

export default withRouter(withDevice(TabBar))
